import React, { useEffect, useRef, useState, useContext } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Task from './Task';
import { TaskContext, PermissionContext } from './../context';
import { Draggable, Droppable } from '@hello-pangea/dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import services from '../services';
import { getMoveBlockedMessage } from '../utils/moveBlocked';
import { boardLocal } from '../utils/LocalSt';
import ConfirmationPopup from './ConfirmationPopup';
import MoveAllTicketsModal from './MoveAllTicketsModal';
import { columnsLocal } from '../utils/LocalSt';
import { AddColumnCall, addColumnsDetails, addForm, getCurrentTask, removeForm, updateForm } from '../Redux/slice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useTaskData } from '../hooks/useTaskData';
import { v4 as uuidv4 } from 'uuid';
import { getLocalStorageItem, setLocalStorageItem } from '../utils/Localstorage/localStorageUtils';
import permission from '../api/permission';
import AllAutomation from './Automation/AllAutomation';
import { Tooltip } from 'react-tooltip';
import Automations from './Automation/Automations'
import IncomingMail from './Automation/IncomingMail';
import AllIncomingAutomation from './Automation/AllIncomingAutomation';
import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AddIcon from "@mui/icons-material/Add";
import { FiPlus } from 'react-icons/fi';
import { canAddTicketToList, canMoveTicketOutOfList } from '../utils/ticketMovePermission';

import { PrivilegesViewChecker, PrivilegesChecker } from '../utils/PrivilegesChecker'

function Column(props) {
    const {
        columnTitle,
        limit,
        id,
        borderColor,
        showkey,
        setStatusUpdate,
        statusUpdate,
        taskDetailsPopup,
        setTaskDetailsPopup,
        getTaskMail,
        taskMail,
        taskAssign,
        setSearchTerm,
        index,
        columnMove,
        columnID,
        searchTerm,
        isShiftPressed,
        moveChildTask,
        handleRemoveChild,
        setIsShiftPressed,
        setConData,
        setColumns,
        setColumnAddStatus,
        handleUpdateTask,
        selectedMyDayPlanDate,
        setSelectedMyDayPlanDate,
        selectedReminderDate,
        setSelectedReminderDate,
        selectedStatusNextStepDate,
        setSelectedStatusNextStepDate,
        note,
        setNote,
        handleDateSelect,
        myDayDate,
        deadlineDate,
        isMyDayChecked,
        isDeadlineChecked,
        setIsMyDayChecked,
        notesText,
        setNotesText,
        setIsDeadlineChecked,
        setMyDayDate,
        setDeadlineDate,
        selectedBoardId,
        toggleTaskDropdown,
        editTaskTitle,
        setEditTaskTitle,
        selectedTaskcolor,
        setSelectedTaskcolor,
        isOpen,
        role,
        openTaskId,
        setIsOpen,
        taskDeleteId,
        showBox,
        setShowBox,
        setIsSearchBoxOpen,
        setHoverIndex,
        setColorIndexID,
        setActivePatch,
        hoverIndex,
        colorIndexID,
        activePatch,
        handleEditTitle,
        clearHighlight,
        handleClick,
        setUpdateTitle,
        updateTitle,
        setIsOpenDeadline,
        isOpenDeadline,
        isSearchBoxOpen,
        deleteTask,
        taskToDelete,
        setTaskToDelete,
        handleCancelDelete,
        setTaskMail,
        getAllBoard,
        activeButton,
        isArchivedBoard,
        supervisorActions,
        onColumnScrollEnd,
        isLoadingMore,
        boardName,
        filterList,
        isMember,
        parentOrigin,
        columnAutomation,
        allCustomFieldList,
        setAllCustomFieldList,
        getAllAutomation,
        userList
    } = props;

    const { permissions, ticketPermissions } = useContext(PermissionContext);




    const privileges = [
        "Add a Task",
        "Add a List",
        "Rename this List",
        "Delete this List",
        "Archive all items in list",
        "Move all tickets",
        "Create automation",
        "Add incomings emails to this list"
    ]


    const showMenuButton = privileges.some(p => PrivilegesViewChecker(p));



    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [moveAllOpen, setMoveAllOpen] = useState(false);
    const [renameMode, setRenameMode] = useState(false);
    const [newTitle, setNewTitle] = useState(columnTitle);
    const [automations, setAutomations] = useState(false);
    const [incomingEmailAutomation, setIncomingEmailAutomation] = useState(false);
    const [step, setStep] = useState(1);
    const [columnStep, setColumnStep] = useState(1);
    const [editId, setEditId] = useState(null);
    const [columneditId, setColumnEditId] = useState(null);
    const [columnAutomations, setColumnAutomations] = useState(false)
    const dispatch = useDispatch();

    const getUserData = () => {
        try {
            const raw = localStorage.getItem("userData");
            if (!raw) return null;
            const parsed = JSON.parse(raw);
            return typeof parsed === "string" ? JSON.parse(parsed) : parsed;
        } catch (e) {
            console.error("Invalid userData in localStorage", e);
            return null;
        }
    };

    const userData = getUserData();
    const isAdmin = userData?.role?.toLowerCase() === "admin";
    // Per-list "add ticket" permission (null = unrestricted: admin / manager)
    const canAddTicketHere =
        !ticketPermissions || canAddTicketToList(ticketPermissions, columnID);
    const permittedItems = [
        { name: 'Add a Task', permission: PrivilegesViewChecker("Add a Task") && canAddTicketHere },
        { name: 'Add a List', permission: PrivilegesViewChecker("Add a List") },
        { name: 'Rename this List', permission: PrivilegesViewChecker("Rename this List") },
        { name: 'Delete this List', permission: PrivilegesViewChecker("Delete this List") },
        { name: 'Archive all items in list', permission: PrivilegesViewChecker("Archive all items in list") },
        {
            name: 'Move all tickets',
            permission:
                PrivilegesChecker("Move all tickets") &&
                (!ticketPermissions || canMoveTicketOutOfList(ticketPermissions, columnID)),
        },
        { name: 'Create automation', permission: PrivilegesViewChecker("Create automation") },
        //Delete  the last option -30-10(Admilson)
        // { name: 'Add incomings emails to this list', permission: PrivilegesViewChecker("Add incomings emails to this list") }
    ].filter(item => item.permission);
    const { columns, columnFormList, selectedTab } = useSelector(
        (state) => ({
            columns: state.redux.columns,
            columnFormList: state.redux.columnFormList,
            selectedTab: state.redux.selectedTab,
        }),
        (prev, next) =>
            prev.columns === next.columns &&
            prev.columnFormList === next.columnFormList &&
            prev.selectedTab === next.selectedTab,
    );

    const forms = (columnFormList || []).filter((f) => f.columnID === columnID);
    const [userName, setUserName] = useState('');
    const columnsData = columnsLocal();
    const [deleteShowBox, setDeleteShowBox] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('');
    const formRefs = React.useRef({});
    const [taskDetailsModal, setTaskDetailModal] = useState(false);
    const [deleteMessage, setDeleteMessage] = useState('');
    const [currentTask, setCurrentTask] = useState(null);
    const clickTimeoutRef = useRef(null);
    const ignoreNextClickRef = useRef(false);
    const [hasColumnAutomation, setHasColumnAutomation] = useState(false);
    const [matchedGmailList, setMatchedGmailList] = useState([]);
    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const setColumnAutomation = async (columnAutomation) => {
        if (!Array.isArray(columnAutomation) || !columnID) {
            setHasColumnAutomation(false);
            setMatchedGmailList([]);
            return;
        }

        const matched = columnAutomation.filter(auto => {
            const createAction = auto.action?.find(
                a => a.action === "createOnList"
            );
            return createAction?.entityId === columnID;
        });

        if (matched.length > 0) {
            setHasColumnAutomation(true);

            const gmailList = matched
                .map(m => {
                    const gmailUserId = m.when?.gmailUserId; // string id
                    const matchedUser = filterList?.find(
                        u => u.value === gmailUserId
                    );
                    return matchedUser?.label;
                })
                .filter(Boolean);

            setMatchedGmailList(gmailList);
        } else {
            setHasColumnAutomation(false);
            setMatchedGmailList([]);
        }
    };



    useEffect(() => {
        setColumnAutomation(columnAutomation)
    }, [columnAutomation, filterList])

    const navigate = useNavigate();
    const {
        moduleName,
        moveTaskToColumn,
        removeTask,
        moveTaskUp,
        moveTaskDown,
        updateColunTitleInLocalStorage,
        getTaskMailIndbox,
    } = React.useContext(TaskContext);

    const archiveAllTasks = async (columnID) => {


        try {
            await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateByColumnId/${columnID}`, {
                boardId: selectedBoardId,
            });
            toast.success('All tasks in the column have been archived.');
            getTaskMail(1, '', selectedBoardId);
            setIsDropdownOpen(false);
        } catch (error) {
            console.error('Error archiving all tasks in column:', error);
            toast.error('Failed to archive all tasks in the column.');
        }
    };
    useEffect(() => {
        if (!selectedBoardId) {
            const savedBoard = getLocalStorageItem('board')
            if (savedBoard) {
                try {
                    const parsedBoard = savedBoard;
                } catch (error) {
                    console.error('Error parsing saved board:', error);
                }
            }
        }
    }, [selectedBoardId]);

    const createTask = async (selectedStatus, title) => {
        const dataObj = {
            boardListId: selectedStatus,
            title: title,
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/task/createTask`, dataObj);
            if (response && selectedBoardId) {
                getTaskMail(1, {}, selectedBoardId);
            }
        } catch (error) {
            console.error('Error creating task:', error);
        }
    };

    const createTaskMail = async (
        gmailMessageID,
        gmailStatus,
        subjectTitle,
        typeOf,
        boardId,
        subThreadId,
        columnIndex,
        selectedBoardId
    ) => {
        let finalBoardId = boardId;
        if (!finalBoardId) {
            finalBoardId = selectedBoardId;
        }

        if (!finalBoardId) {
            const savedBoard = getLocalStorageItem('board')
            if (savedBoard) {
                try {
                    const parsedBoard = savedBoard;
                    finalBoardId = parsedBoard.value;
                } catch (error) {
                    console.error('Error parsing saved board:', error);
                }
            }
        }

        if (!finalBoardId) {
            console.error('No board ID available for creating task');
            toast.error('Please select a board before creating a task');
            return;
        }

        let dataObj = {
            boardListId: gmailStatus,
            title: subjectTitle,
            taskType: typeOf ? typeOf : 'Gmail',
            boardId: finalBoardId,
            ...(userData?.role === "User" ? { userId: userData?.id } : {}),
        };
        if (subThreadId !== undefined && subThreadId !== null) {
            dataObj.subThreadId = subThreadId;
        }
        if (typeOf === 'Whatsapp') {
            dataObj = {
                ...dataObj,
                contactId: gmailMessageID,
            };
        } else {
            dataObj = {
                ...dataObj,
                gmailMessageId: gmailMessageID,
            };
        }
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/task/createTask`, dataObj, {
                headers: {
                    Authorization: `Bearer ${localStorage?.getItem('access_token')}`,
                },
            });
            updateStatusTask(response?.data?.data?.id, boardId);
            if (response && boardId) {
                getAllTaskMail(columnIndex, response?.data?.data?.id, boardId);
                // getTaskMailIndbox();
            }
        } catch (error) {
            console.error('Error creating task mail:', error);
        }
    };

    const getGmailUsers = async () => {
        try {
            const response = await services.email.Get_The_Linked_Email();
            if (response?.data) {
                const gmailOptions = response.data.map((item) => ({
                    value: item.id,
                    label: item.email,
                }));
                setFilterList(gmailOptions);
            }
        } catch (error) {
            console.error('Error fetching Gmail users:', error);
        }
    };
    useEffect(() => {
        if (!renameMode) return;
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setRenameMode(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [renameMode]);

    const getAllTaskMail = async (columnIndex, taskId, selectedBoardId) => {
        const query = {
            limit: 800,
            boardId: selectedBoardId,
        };

        if (activeButton == 'table') {
            query.sortBy = sortby;
            query.sortOrder = sortOrder;
            query.query = 'table';
        }

        const obj = new URLSearchParams(query);

        try {
            const response = await services.task.GET_TASK(obj);
            if (response) {
                let data = JSON.parse(JSON.stringify(response?.data?.data));
                const allTaskData = data[columnID] || [];

                moveTask(taskId, columnID, columnIndex, allTaskData, 'task', selectedBoardId);
            }
        } catch (error) {
            console.error('Error fetching task emails:', error);
        }
    };





    const handleRenameClick = () => {
        setRenameMode(true);
        setIsDropdownOpen(false);
    };




    const handleColumnKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleRenameColumn();
            setRenameMode(false);
        }
    };





    const updateStatusTask = async (id, boardId) => {


        const isValidUUID =
            typeof id === "string" && id.includes("-");

        if (!isValidUUID) {
            return;
        }


        const data = {
            boardListId: columnID,
        };
        try {
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${id}`, data);
            if (response && boardId) {
                getTaskMail(1, {}, boardId);
            }
        } catch (error) {
            console.error('Error updating task status:', error);
        }
    };

    const updateStatusEmail = async (id) => {
        const data = {
            gmailStatus: columnTitle,
        };
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/email/updateStatusEmail/${id}`,
                data,
            );
            if (response) {
                const gmailMessageId = response?.data?.data?.gmailMessageId;
                const gmailStatus = response?.data?.data?.gmailStatus;
                const subjectTitle = response?.data?.data?.subject;
                createTaskMail(gmailMessageId, gmailStatus, subjectTitle, 'Gmail', selectedBoardId, undefined, undefined, selectedBoardId);
                getTaskMailIndbox();
                getTaskMail();
            }
        } catch (error) {
            console.error('Error updating email status:', error);
        }
    };

    // Removal of react-dnd hooks here
    const isOver = false;
    const isDragging = false;
    const drop = () => { };
    const dragRef = () => { };
    const dropRef = () => { };


    const ref = React.useRef(null);

    const handleRenameColumn = async () => {
        const data = { coloum: newTitle, boardId: selectedBoardId };
        try {
            const response = await services?.column?.RENAME_COLUMN(data, columnID);
            const updatedColumns = columns?.length > 0 && columns.map((column) => {
                if (column.id === columnID) {
                    return { ...column, title: newTitle };
                }
                return column;
            });
            dispatch(addColumnsDetails(updatedColumns));
            setRenameMode(false);
            const colId = response?.data?.data?.id;
            await services.board.SELECTED_BOARD(colId);
        } catch (e) {
            console.error(e);
            toast.error('Failed to rename list.');
        }
    };

    const [boradList, setBoardList] = useState([]);
    const getAllBoardDateTable = async () => {
        try {
            const response = await services.board.GET_BOARD_LIST();
            setBoardList(response?.data?.data);
        } catch (error) {
            console.error('❌ Error fetching board date table:', error);
        }
    };

    // Redundant mount-level API call removed to prevent multiple calls on board change
    // useEffect(() => {
    //     getAllBoardDateTable();
    // }, []);

    const deleteTaskMail = async () => {
        if (columns.length <= 1) {
            toast.error(
                "You can't delete the last list on your board. You can rename this list if you want to change its heading.",
            );
            setDeleteShowBox(false);
            return;
        }
        const tasksInColumn = getTasksForColumn(columnID);

        if (tasksInColumn.length > 0) {
            toast.error("You can't delete this Column. It has tasks in it please move them to another column.");
            setDeleteShowBox(false);
            return;
        }


        try {
            const response = await services.column.DELETE_COLUMN(columnID);
            if (response) {
                const filterData = columns?.length > 0 && columns.filter(({ id }) => id !== columnID);
                if (filterData.length === 0) {
                    toast.error(
                        "You can't delete the last list on your board. You can rename this list if you want to change its heading.",
                    );
                    return;
                }

                const updatedFilterData = filterData?.length > 0 && filterData.map((column, index) => ({
                    ...column,
                    sequence: index + 1,
                }));

                dispatch(addColumnsDetails(updatedFilterData));

                setLocalStorageItem('columns', updatedFilterData)
                setConData(updatedFilterData);
                setColumns(updatedFilterData);

                const sequenceData = updatedFilterData.map(({ id, sequence }) => ({ id, sequence }));
                await services.board.SEQUENCE(sequenceData, selectedBoardId);

                setDeleteShowBox(false);
            }
        } catch (error) {
            console.error('Error deleting column:', error);
            toast.error('Failed to delete the column.');
            setDeleteShowBox(false);
        }
    };



    const [lastAddedTaskId, setLastAddedTaskId] = useState(null);
    const [lastAddedSource, setLastAddedSource] = useState(null);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [openAddTaskModal, setOpenAddTaskModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [taskTitle, setTaskTitle] = useState("");
    const [addTaskModalStyle, setAddTaskModalStyle] = useState({ position: 'fixed', top: 100, left: 20, zIndex: 10000 });
    const columnRef = useRef(null);


    const addNewForm = async (source) => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        let finalBoardId = selectedBoardId;
        if (!finalBoardId) {
            const savedBoard = getLocalStorageItem('board');
            const savedBoardId = getLocalStorageItem('boardId');
            
            if (savedBoard) {
                finalBoardId = typeof savedBoard === 'object' ? savedBoard.value : savedBoard;
            } else if (savedBoardId) {
                finalBoardId = savedBoardId;
            }
        }

        if (!finalBoardId) {
            console.error('No boardId found for CREATE_TASK');
            // toast.error('Board ID missing. Please refresh the page.');
            // setIsSubmitting(false);
            // return;
        }

        const newForm = {
            boardListId: columnID,
            title: taskTitle?.trim() || "type your task name here",
            taskType: selectedTab === 'GMAIL' || selectedTab === 'GMAIL_BOARD' || selectedTab === 'WEBMAIL' || selectedTab === 'OUTLOOK' ? 'Gmail' : 'Whatsapp',
            boardId: finalBoardId,
            ...(userData?.role === "User" ? { userId: userData?.id } : {}),
        };

        try {
            const response = await services.task.CREATE_TASK(newForm);

            if (response) {
                setOpenAddTaskModal(false)
                setTaskTitle("");
                const newTask = response.data.data;
                const currentTasks = getTasksForColumn(columnID);
                let newTasks;

                if (source === 'Add a task') {
                    newTasks = [newTask, ...currentTasks];
                } else {
                    newTasks = [...currentTasks, newTask];
                }

                setTaskMail((prevTaskMail) => ({
                    ...prevTaskMail,
                    [columnID]: newTasks,
                }));

                if (source === 'Add a task') {
                    const beforeTaskId = currentTasks.length > 0 ? currentTasks[0].id : null;
                    const payload = {
                        taskId: newTask.id,
                        beforeTaskId: beforeTaskId,
                        afterTaskId: null,
                        boardListId: columnID,
                    };
                    await services.task?.MOVE_TASK_DRAG_DROP(payload);
                }
            }
        } catch (error) {
            console.error('Error creating task mail:', error);
            toast.error('Failed to create task. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const updateFormTitle = (formId, title) => {
        dispatch(updateForm({ id: formId, title }));
    };

    const closeForm = (formId) => {
        dispatch(removeForm(formId));
    };

    let clickTimeout = null;

    const handleSingleClick = (item, e, isForm) => {
        if (ignoreNextClickRef.current) {
            ignoreNextClickRef.current = false;
            return;
        }

        if (e.target.closest('[data-no-popup]')) return;

        if (clickTimeoutRef.current) {
            clearTimeout(clickTimeoutRef.current);
        }

        clickTimeoutRef.current = setTimeout(() => {
            if (!ignoreNextClickRef.current) {
                handleTaskDetailPopup(item, e, isForm);
            }
        }, 300);
    };

    const handleTaskDetailPopup = (item, event, isForm) => {

        if (item) {
            const columnTasks = getTasksForColumn(columnID);
            // Active board filters live in sessionStorage (set by AppViewer), not as a
            // prop on Column, so read them from there to build the nav context below.
            let persistedFilters = [];
            try {
                persistedFilters = JSON.parse(sessionStorage.getItem('kanbanFilters')) || [];
            } catch (e) {
                persistedFilters = [];
            }
            navigate(`/detail/${item.id}`, {
                state: {
                    selectedMail: item,
                    deadlineDate: deadlineDate,
                    taskID: item.id,
                    clickMailTask: true,
                    type: 'Gmail',
                    openTaskDataSidebar: true,
                    currentTask: item,
                    boardId: selectedBoardId,
                    boardName: boardName,
                    isMember: isMember,
                    parentOrigin: parentOrigin,
                    // Powers Previous/Next ticket navigation on the detail page:
                    // navTasks is the already-loaded list for an instant first render,
                    // navContext lets the detail page fetch the full, authoritative,
                    // filtered list (beyond whatever page has been scrolled into view).
                    navTasks: columnTasks,
                    navContext: {
                        boardId: selectedBoardId,
                        columnId: columnID,
                        filters: persistedFilters,
                        activeButton,
                        sortby: props.sortby,
                        sortOrder: props.sortOrder,
                    },
                },
            });
        } else if (item.Email == undefined) {
            setTaskDetailModal(true);
        } else {
            setTaskDetailModal(false);
            setCurrentTask(item);
            dispatch(getCurrentTask(item));
        }
    };

    const taskData = useTaskData();

    const normalizeTaskMailState = (rawState) => {
        if (Array.isArray(rawState)) {
            return rawState.reduce((acc, item) => {
                const colId = item?.BoardList?.id || item?.boardListId;
                if (!colId) return acc;
                if (!acc[colId]) acc[colId] = [];
                acc[colId].push(item);
                return acc;
            }, {});
        }
        if (rawState && typeof rawState === 'object') {
            return rawState;
        }
        return {};
    };

    const getTasksForColumn = (colId) => {
        const normalized = normalizeTaskMailState(taskMail);
        return normalized[colId] || [];
    };

    let tasksInColumn = getTasksForColumn(columnID);

    if (lastAddedTaskId && lastAddedSource && tasksInColumn.some((t) => t.id === lastAddedTaskId)) {
        const idx = tasksInColumn.findIndex((t) => t.id === lastAddedTaskId);
        const [lastTask] = tasksInColumn.splice(idx, 1);
        if (lastAddedSource === 'Add a task') {
            tasksInColumn = [lastTask, ...tasksInColumn];
        } else if (lastAddedSource === 'column-list') {
            tasksInColumn = [...tasksInColumn, lastTask];
        }
    }
    const moveTaskToIndex = (taskId, toIndex) => {
        const tasks = [...getTasksForColumn(columnID)];
        const fromIndex = tasks.findIndex((task) => task.id === taskId);
        if (fromIndex === -1 || fromIndex === toIndex) return;
        const [movedTask] = tasks.splice(fromIndex, 1);
        tasks.splice(toIndex, 0, movedTask);

        setTaskMail((prev) => {
            const normalizedPrev = normalizeTaskMailState(prev);
            return {
                ...normalizedPrev,
                [columnID]: tasks,
            };
        });

        moveTask(taskId, columnID, toIndex, tasks);
    };
    const moveTaskInState = (fromIndex, toIndex, colId) => {
        if (fromIndex === toIndex) return;
        setTaskMail((prev) => {
            const normalizedPrev = normalizeTaskMailState(prev);
            const columnTasks = [...(normalizedPrev[colId] || [])];
            const [moved] = columnTasks.splice(fromIndex, 1);
            columnTasks.splice(toIndex, 0, moved);
            return { ...normalizedPrev, [colId]: columnTasks };
        });
    };

    const moveTaskToOtherColumnInState = (fromIndex, toIndex, fromColumnId, toColumnId, movedTask) => {
        setTaskMail((prev) => {
            const sourceTasks = [...(prev[fromColumnId] || [])];
            const targetTasks = [...(prev[toColumnId] || [])];

            sourceTasks.splice(fromIndex, 1);
            targetTasks.splice(toIndex, 0, movedTask);

            return {
                ...prev,
                [fromColumnId]: sourceTasks,
                [toColumnId]: targetTasks,
            };
        });
    };

    const moveTask = async (dragTaskId, toColumnId, toIndex, updatedTasks, type, boardId) => {
        let beforeTaskId = null;
        let afterTaskId = null;
        if (toIndex === 0) {
            beforeTaskId = updatedTasks[1]?.id || null;
        } else if (toIndex === updatedTasks.length - 1) {
            afterTaskId = updatedTasks[updatedTasks.length - 2]?.id || null;
        } else {
            afterTaskId = updatedTasks[toIndex - 1]?.id || null;
            beforeTaskId = updatedTasks[toIndex + 1]?.id || null;
        }

        if (type === 'Manual-Task') {
            beforeTaskId = null;
        }

        const payload = {
            taskId: dragTaskId,
            beforeTaskId,
            afterTaskId,
            boardListId: toColumnId,
        };

        try {
            await services.task?.MOVE_TASK_DRAG_DROP(payload);
            if (boardId) {
                getTaskMail(1, {}, boardId);
            }
        } catch (error) {
            console.error('❌ Error in moveTask:', error);
            // e.g. the list's mandatory checklist is not done yet: say why and resync the board
            const blocked = getMoveBlockedMessage(error);
            if (blocked) {
                toast.error(blocked);
                if (boardId) getTaskMail(1, {}, boardId);
            }
        }
    };
    useEffect(() => {
        setNewTitle(columnTitle);
    }, [columnTitle, columnID]);

    const columnScrollRef = useRef(null);

    useEffect(() => {
        const el = columnScrollRef.current;
        if (!el) return;
        const onScroll = () => {
            const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 40;
            if (nearBottom && typeof onColumnScrollEnd === 'function') {
                onColumnScrollEnd();
            }
        };
        el.addEventListener('scroll', onScroll, { passive: true });
        return () => el.removeEventListener('scroll', onScroll);
    }, [onColumnScrollEnd]);


    return (
        <>
            <Draggable draggableId={String(columnID)} index={index}>
                {(provided, snapshot) => (
                    <div
                        ref={(node) => {
                            provided.innerRef(node);
                            columnRef.current = node;
                        }}
                        {...provided.draggableProps}
                        style={{
                            ...provided.draggableProps.style,
                            opacity: snapshot.isDragging ? 0.5 : 1,
                            textAlign: 'center',
                            minWidth: '330px',
                            width: '330px',
                        }}
                        className={`column-draggable column-accent-${index % 6}`}
                    >
                        <div className="droptarget" style={{ backgroundColor: 'transparent', position: 'relative' }}>
                            <div className="title-contents drop-relative flex-col mt-1" {...provided.dragHandleProps}>
                                <div className="header-Flex" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <h2 className="title-column title-box" style={{
                                        marginRight: "6px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        flex: 1,
                                    }} onDoubleClick={() => setRenameMode(true)}>
                                        {renameMode ? (
                                            <input
                                                type="text"
                                                value={newTitle}
                                                onChange={(e) => setNewTitle(e.target.value)}
                                                onKeyDown={handleColumnKeyDown}
                                                onBlur={() => {
                                                    handleRenameColumn();
                                                    setRenameMode(false);
                                                }}

                                                autoFocus
                                            />
                                        ) : (
                                            <span>{newTitle}</span>
                                        )}
                                    </h2>


                                    {!showkey && (
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                marginLeft: '10px',
                                                paddingRight: '6px',
                                            }}
                                        >
                                            {showMenuButton && (
                                                <IconButton
                                                    size="small"
                                                    onClick={toggleDropdown}
                                                    sx={{
                                                        p: "2px",
                                                        backgroundColor: "#dfe9f8ff",
                                                        color: "#121b2bff",
                                                        "&:hover": { backgroundColor: "#E4E7EC" },
                                                        width: 28,
                                                        height: 28,
                                                    }}
                                                >
                                                    <KeyboardArrowDownIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                            {PrivilegesViewChecker("Add a Task") && canAddTicketHere && (
                                                <IconButton
                                                    size="small"
                                                    onClick={(e) => {
                                                        const btnRect = e.currentTarget.getBoundingClientRect();
                                                        const colRect = columnRef.current?.getBoundingClientRect();
                                                        const modalWidth = 250;
                                                        const modalHeight = 120;
                                                        const viewportWidth = window.innerWidth;
                                                        const viewportHeight = window.innerHeight;
                                                        let left = colRect
                                                            ? colRect.left + (colRect.width - modalWidth) / 2
                                                            : (viewportWidth - modalWidth) / 2;
                                                        left = Math.max(10, Math.min(left, viewportWidth - modalWidth - 10));
                                                        let top = btnRect.bottom + 8;
                                                        const spaceBelow = viewportHeight - btnRect.bottom - 16;
                                                        const spaceAbove = btnRect.top - 16;
                                                        if (spaceBelow < modalHeight && spaceAbove > modalHeight) {
                                                            top = Math.max(10, btnRect.top - modalHeight - 8);
                                                        } else {
                                                            top = Math.min(top, viewportHeight - modalHeight - 10);
                                                        }
                                                        setAddTaskModalStyle({
                                                            position: 'fixed',
                                                            top,
                                                            left,
                                                            zIndex: 10000,
                                                            maxHeight: 'calc(100vh - 20px)',
                                                            overflowY: 'auto',
                                                        });
                                                        setOpenAddTaskModal(true);
                                                    }}
                                                    sx={{
                                                        p: "2px",
                                                        backgroundColor: "#dfe9f8ff",
                                                        color: "#121b2bff",
                                                        "&:hover": { backgroundColor: "#E4E7EC" },
                                                        width: 28,
                                                        height: 28,
                                                    }}
                                                >
                                                    <AddIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                        </div>
                                    )}


                                </div>

                                <div
                                    className="column-color-bar"
                                    style={borderColor ? { background: borderColor } : {}}
                                />

                                {hasColumnAutomation && <div onClick={() => setIncomingEmailAutomation(true)} style={{ cursor: "pointer" }} class="d-flex align-items-center bg-light rounded px-2 py-1">
                                    <i class="bi bi-caret-down-fill me-2 text-secondary small"></i>
                                    <span class="small">
                                        Emails incoming from
                                        <a
                                            className="link-primary text-decoration-none fw-medium ms-1"
                                            data-tooltip-id="matched-email-tooltip"
                                            data-tooltip-content={matchedGmailList.join(", ")}
                                        >
                                            {matchedGmailList.length > 1
                                                ? `${matchedGmailList[0]} ...`
                                                : matchedGmailList[0] || "N/A"}
                                        </a>

                                    </span>
                                </div>}
                                {isDropdownOpen && permittedItems.length > 0 && (
                                    <div>
                                        <div onClick={toggleDropdown} className="layout-backdrop"></div>
                                        <div className="headtag-card" style={{ cursor: 'pointer' }}>
                                            <ul className="start-list">
                                                {permittedItems.map((item, index) => (
                                                    <li key={index}>
                                                        <a
                                                            onClick={() => {
                                                                if (item.name === 'Add a Task') {
                                                                    addNewForm('Add a Task');
                                                                    setIsDropdownOpen(false);
                                                                } else if (item.name === 'Rename this List') {
                                                                    handleRenameClick();
                                                                } else if (item.name === 'Create automation') {
                                                                    setAutomations(!automations)
                                                                } else if (item.name === 'Delete this List') {
                                                                    const tasksInColumn = taskMail?.[columnID] || [];

                                                                    if (tasksInColumn.length > 0) {
                                                                        setDeleteMessage(
                                                                            "You can't delete this Column. It has tasks in it please move them to another column.",
                                                                        );
                                                                        setDeleteShowBox(true);
                                                                        setIsDropdownOpen(false);
                                                                    } else {
                                                                        setDeleteShowBox(true);
                                                                        setIsDropdownOpen(false);
                                                                    }
                                                                } else if (item.name === 'Add a List') {
                                                                    setColumnAddStatus(true);
                                                                    dispatch(AddColumnCall());
                                                                } else if (item.name === 'Archive all items in list') {
                                                                    archiveAllTasks(columnID);
                                                                } else if (item.name === 'Move all tickets') {
                                                                    setMoveAllOpen(true);
                                                                    setIsDropdownOpen(false);
                                                                } else if (item.name === 'Add incomings emails to this list') {

                                                                    if (columnAutomation.length > 0) {
                                                                        setColumnStep(1)
                                                                        setIncomingEmailAutomation(true);
                                                                    } else {
                                                                        setColumnStep(2)
                                                                        setColumnAutomations(true)
                                                                    }
                                                                }
                                                            }}
                                                        > {item.name === 'Add a Task' && <div className=""></div>}
                                                            {item.name === 'Add a List' && <div className=""></div>}
                                                            {item.name === 'Rename this List' && <div className=""></div>}
                                                            {item.name === 'Delete this List' && <div className=""></div>}
                                                            {item.name === 'Mark all items in list complete' && (
                                                                <div className=""></div>
                                                            )}
                                                            {/* {item.name === 'Archive all items in list' && (
                                                        <div className="underline-list"></div>
                                                    )} */}
                                                            {item.name === 'Add incomings emails to this list' && (
                                                                <div className=""></div>
                                                            )}
                                                            {item.name === 'Create automation' && <div></div>}
                                                            <div className="currentDay">
                                                                {item.name && item.name.charAt(0).toUpperCase() + item.name.slice(1)}
                                                                <div>{item.dayName}</div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                )}

                                {moveAllOpen && (
                                    <MoveAllTicketsModal
                                        fromListId={columnID}
                                        fromBoardId={selectedBoardId}
                                        isAdmin={isAdmin}
                                        userId={userData?.id}
                                        onClose={() => setMoveAllOpen(false)}
                                        onMoved={() => getTaskMail(1, '', selectedBoardId)}
                                    />
                                )}

                                {openAddTaskModal &&
                                    ReactDOM.createPortal(
                                        <>
                                            <div className="layout-backdrop" onClick={() => { setOpenAddTaskModal(false); setIsSubmitting(false); }}></div>
                                            <div
                                                className="add-task-popover"
                                                style={addTaskModalStyle}
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <div className="add-task-popover__header">
                                                    <span className="add-task-popover__icon" aria-hidden="true">
                                                        <FiPlus size={15} color="#ffffff" />
                                                    </span>
                                                    <span className="add-task-popover__title">New task</span>
                                                </div>
                                                <input
                                                    className="add-task-popover__input"
                                                    placeholder="Enter Task title..."
                                                    value={taskTitle}
                                                    onChange={(e) => setTaskTitle(e.target.value)}
                                                    autoFocus
                                                />
                                                <div className="add-task-popover__actions">
                                                    <button
                                                        type="button"
                                                        className="add-task-popover__btn-cancel"
                                                        onClick={() => {
                                                            setOpenAddTaskModal(false);
                                                            setTaskTitle("");
                                                            setIsSubmitting(false);
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="add-task-popover__btn-save"
                                                        onClick={() => addNewForm("Add a task")}
                                                        disabled={isSubmitting}
                                                    >
                                                        {isSubmitting ? "Saving..." : "Save"}
                                                    </button>
                                                </div>
                                            </div>
                                        </>,
                                        document.body
                                    )
                                }




                            </div>

                            <Droppable droppableId={String(columnID)} isCombineEnabled={true} >
                                {(providedTask, snapshotTask) => (
                                    <div
                                        ref={(node) => {
                                            columnScrollRef.current = node;
                                            providedTask.innerRef(node);
                                        }}
                                        {...providedTask.droppableProps}
                                        className="inbox-Task-scroll"
                                        style={{ backgroundColor: snapshotTask.isDraggingOver ? '#f4f5f7' : 'transparent', minHeight: '100px' }}
                                    >
                                        {taskMail &&
                                            getTasksForColumn(columnID).map((item, indexId) => (
                                                <Task
                                                    parentOrigin={parentOrigin}
                                                    isMember={isMember}
                                                    key={item.id}
                                                    item={item}
                                                    moveTaskToColumn={moveTaskToColumn}
                                                    moveTaskUp={moveTaskUp}
                                                    moveTaskDown={moveTaskDown}
                                                    removeTask={removeTask}
                                                    indexId={indexId}
                                                    getTaskMail={getTaskMail}
                                                    showForm={forms.length > 0}
                                                    columnTitle={columnTitle}
                                                    setTaskDetailsPopup={setTaskDetailsPopup}
                                                    taskDetailsPopup={taskDetailsPopup}
                                                    taskDeadline={item.deadline}
                                                    userAssigneeName={item?.userId}
                                                    taskColor={item?.color}
                                                    taskAssign={taskAssign}
                                                    userList={userList}
                                                    setSearchTerm={setSearchTerm}
                                                    searchTerm={searchTerm}
                                                    isShiftPressed={isShiftPressed}
                                                    moveChildTask={moveChildTask}
                                                    columnID={columnID}
                                                    handleRemoveChild={handleRemoveChild}
                                                    setIsShiftPressed={setIsShiftPressed}
                                                    getTaskMailIndbox={getTaskMailIndbox}
                                                    setSelectedMyDayPlanDate={setSelectedMyDayPlanDate}
                                                    selectedMyDayPlanDate={selectedMyDayPlanDate}
                                                    handleUpdateTask={handleUpdateTask}
                                                    selectedReminderDate={selectedReminderDate}
                                                    setSelectedReminderDate={setSelectedReminderDate}
                                                    selectedStatusNextStepDate={selectedStatusNextStepDate}
                                                    setSelectedStatusNextStepDate={setSelectedStatusNextStepDate}
                                                    note={note}
                                                    setNote={setNote}
                                                    handleDateSelect={handleDateSelect}
                                                    myDayDate={myDayDate}
                                                    deadlineDate={deadlineDate}
                                                    isMyDayChecked={isMyDayChecked}
                                                    isDeadlineChecked={isDeadlineChecked}
                                                    setIsMyDayChecked={setIsMyDayChecked}
                                                    setIsDeadlineChecked={setIsDeadlineChecked}
                                                    notesText={notesText}
                                                    setNotesText={setNotesText}
                                                    setMyDayDate={setMyDayDate}
                                                    setDeadlineDate={setDeadlineDate}
                                                    handleSingleClick={handleSingleClick}
                                                    handleTaskDetailPopup={handleTaskDetailPopup}
                                                    taskDetailsModal={taskDetailsModal}
                                                    setTaskDetailModal={setTaskDetailModal}
                                                    currentTask={currentTask}
                                                    setCurrentTask={setCurrentTask}
                                                    toggleTaskDropdown={toggleTaskDropdown}
                                                    editTaskTitle={editTaskTitle}
                                                    setEditTaskTitle={setEditTaskTitle}
                                                    selectedTaskcolor={selectedTaskcolor}
                                                    setSelectedTaskcolor={setSelectedTaskcolor}
                                                    isOpen={openTaskId === item.id}
                                                    setIsOpen={setIsOpen}
                                                    taskDeleteId={taskDeleteId}
                                                    showBox={showBox}
                                                    setShowBox={setShowBox}
                                                    setIsSearchBoxOpen={setIsSearchBoxOpen}
                                                    setHoverIndex={setHoverIndex}
                                                    setColorIndexID={setColorIndexID}
                                                    setActivePatch={setActivePatch}
                                                    hoverIndex={hoverIndex}
                                                    colorIndexID={colorIndexID}
                                                    activePatch={activePatch}
                                                    clickTimeoutRef={clickTimeoutRef}
                                                    ignoreNextClickRef={ignoreNextClickRef}
                                                    handleEditTitle={handleEditTitle}
                                                    clearHighlight={clearHighlight}
                                                    handleClick={handleClick}
                                                    setUpdateTitle={setUpdateTitle}
                                                    updateTitle={updateTitle}
                                                    setIsOpenDeadline={setIsOpenDeadline}
                                                    isOpenDeadline={isOpenDeadline}
                                                    isSearchBoxOpen={isSearchBoxOpen}
                                                    deleteTask={deleteTaskMail}
                                                    taskToDelete={taskToDelete}
                                                    setTaskToDelete={setTaskToDelete}
                                                    selectedBoardId={selectedBoardId}
                                                    handleCancelDelete={handleCancelDelete}
                                                    {...taskData}
                                                    allTaskData={taskMail}
                                                    setTaskMail={setTaskMail}
                                                    moveTask={moveTask}
                                                    hoveredIndex={hoveredIndex}
                                                    setHoveredIndex={setHoveredIndex}
                                                    moveTaskToIndex={moveTaskToIndex}
                                                    updateStatusTask={updateStatusTask}
                                                    createTaskMail={createTaskMail}
                                                    setStatusUpdate={setStatusUpdate}
                                                    moveTaskInState={moveTaskInState}
                                                    moveTaskToOtherColumnInState={moveTaskToOtherColumnInState}
                                                    isArchivedBoard={isArchivedBoard}
                                                    supervisorActions={supervisorActions}
                                                    allCustomFieldList={allCustomFieldList}
                                                />
                                            ))}
                                        {providedTask.placeholder}
                                        {isLoadingMore && (
                                            <div className="column-loading-more" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 0' }}>
                                                <div className="column-loading-spinner" style={{
                                                    width: '18px',
                                                    height: '18px',
                                                    border: '2px solid #d0d5dd',
                                                    borderTopColor: '#475467',
                                                    borderRadius: '50%',
                                                    animation: 'column-spin 0.7s linear infinite',
                                                }} />
                                            </div>
                                        )}
                                        {PrivilegesViewChecker("Add a Task") && canAddTicketHere && (
                                            <div
                                                className="task task-curve"
                                                style={hoveredIndex === getTasksForColumn(columnID).length ? { marginTop: '40px' } : {}}
                                            >
                                                <button
                                                    style={{ opacity: '0.3' }}
                                                    onClick={(e) => {
                                                        const btnRect = e.currentTarget.getBoundingClientRect();
                                                        const colRect = columnRef.current?.getBoundingClientRect();
                                                        const modalWidth = 280;
                                                        const modalHeight = 150;
                                                        const viewportWidth = window.innerWidth;
                                                        const viewportHeight = window.innerHeight;
                                                        
                                                        // Calculate horizontal position
                                                        let left = colRect
                                                            ? colRect.left + (colRect.width - modalWidth) / 2
                                                            : (viewportWidth - modalWidth) / 2;
                                                        left = Math.max(10, Math.min(left, viewportWidth - modalWidth - 10));
                                                        
                                                        // Calculate vertical position with fallback
                                                        let top = btnRect.bottom + 8;
                                                        
                                                        // If modal goes below viewport, position it above the button
                                                        if (top + modalHeight > viewportHeight - 20) {
                                                            top = Math.max(10, btnRect.top - modalHeight - 8);
                                                        }
                                                        
                                                        setAddTaskModalStyle({ 
                                                            position: 'fixed', 
                                                            top, 
                                                            left, 
                                                            zIndex: 10000,
                                                            maxHeight: '180px',
                                                            overflowY: 'auto'
                                                        });
                                                        setOpenAddTaskModal(true);
                                                    }}
                                                    className="add-task-button"
                                                >
                                                    <FontAwesomeIcon icon={faPlus} />
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Droppable>
                        </div>
                    </div>
                )}
            </Draggable>
            {deleteShowBox && (
                <ConfirmationPopup
                    customMessage={deleteMessage}
                    boardName={columnTitle}
                    taskToDeleteId={''}
                    onCancel={() => setDeleteShowBox(false)}
                    deleteTaskMail={deleteTaskMail}
                />
            )
            }
            <div>
                {automations && step === 1 && (
                    <AllAutomation
                        show={automations}
                        onHide={() => {
                            setAutomations(false);
                            setStep(1);
                        }}
                        step={step}
                        setStep={setStep}
                        setAutomations={setAutomations}
                        editId={editId}
                        setEditId={setEditId}
                    />
                )}
                {automations && step === 2 && (
                    <Automations
                        show={automations}
                        setAutomations={setAutomations}
                        onHide={() => {
                            setAutomations(false);
                            setStep(1);
                        }}
                        boardName={boardName}
                        gmailUsers={filterList}
                        step={step}
                        setStep={setStep}
                        editId={editId}
                        setEditId={setEditId}
                    />
                )}
                {incomingEmailAutomation && (
                    <AllIncomingAutomation
                        show={incomingEmailAutomation}
                        step={columnStep}
                        setStep={setColumnStep}
                        editId={columneditId}
                        setEditId={setColumnEditId}
                        setIncomingEmailAutomation={setIncomingEmailAutomation}
                        onHide={() => {
                            getAllAutomation()
                            setColumnEditId(null)
                            setIncomingEmailAutomation(false)
                        }}
                    />
                )}
                {columnAutomations && (
                    <IncomingMail
                        show={columnAutomations}
                        setAutomations={setColumnAutomations}
                        onHide={() => {
                            setColumnAutomations(false)
                            setColumnStep(1)
                            if (columnAutomation.length > 0) {
                                setIncomingEmailAutomation(true)
                            }

                        }}
                        getAllAutomation={getAllAutomation}
                        step={columnStep}
                        setStep={setColumnStep}
                        editId={columneditId}
                        setEditId={setColumnEditId}
                    />
                )}
            </div>
            <Tooltip id="matched-email-tooltip" place="top" />

        </>
    );
}

export default Column;
